/* eslint-disable no-undef, camelcase */
// Sets webpack's runtime publicPath based on where this JS bundle is actually
// loaded from. This is critical when the build is hosted in a sub-folder that
// does not match the URL path (e.g. WordPress plugin serving the SPA from
// /wp-content/.../ but URL is /stop-syndrome-imposteur/). Without this,
// webpack-managed assets (images, fonts) would 404.
(function setRuntimePublicPath() {
  if (typeof document === "undefined") return;
  const scripts = document.getElementsByTagName("script");
  let scriptSrc = "";
  for (let i = scripts.length - 1; i >= 0; i--) {
    const s = scripts[i].src || "";
    if (s.indexOf("/static/js/") !== -1) {
      scriptSrc = s;
      break;
    }
  }
  if (!scriptSrc) return;
  // Strip everything from "static/js/main.HASH.js" onwards to get the base.
  const base = scriptSrc.replace(/static\/js\/[^/?]+(\?.*)?$/, "");
  if (base) {
    // eslint-disable-next-line no-global-assign
    __webpack_public_path__ = base;
  }
})();
